import {
  ImageGallery,
  ImageGalleryImage,
  useSlideLayout,
} from '@gripp/shared-ui';
import { useCallback } from 'react';
import { View } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';
import { filesSharedStyles } from './filesSharedStyles';

export const GalleryHeaderActions = () => {
  return null;
};

export const GalleryPanel = ({
  images,
  initialIndex,
  disableImageChange = false,
}: {
  images: ImageGalleryImage[];
  initialIndex: number;
  disableImageChange?: boolean;
}) => {
  const { setColumnTitle } = useSlideLayout();
  const navigate = useNavigate();
  const { assetId } = useParams();

  const handleImageChange = useCallback(
    (index: number) => {
      if (disableImageChange) {
        return;
      }

      const image = images[index];
      if (image?.name) {
        const name = image.name;
        setColumnTitle(name.length > 30 ? `${name.substring(0, 27)}...` : name);
      }
      if (image?.id && assetId) {
        navigate(`/assets/${assetId}/files/${image.id}`, { replace: true });
      }
    },
    [images, setColumnTitle, disableImageChange, navigate, assetId]
  );

  if (images.length === 0) return null;

  return (
    <View style={filesSharedStyles.galleryPanel}>
      <ImageGallery
        key={`${initialIndex}-${images[0]?.id}`}
        images={images}
        initialIndex={initialIndex}
        showThumbnails={images.length > 1}
        showHeader={false}
        disableImageChange={disableImageChange}
        onImageChange={handleImageChange}
      />
    </View>
  );
};
